/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkTypeResponseDto } from './WorkTypeResponseDto';
import {
    WorkTypeResponseDtoFromJSON,
    WorkTypeResponseDtoFromJSONTyped,
    WorkTypeResponseDtoToJSON,
    WorkTypeResponseDtoToJSONTyped,
} from './WorkTypeResponseDto';

/**
 * 
 * @export
 * @interface ListWorkTypesResponseDto
 */
export interface ListWorkTypesResponseDto {
    /**
     * 
     * @type {Array<WorkTypeResponseDto>}
     * @memberof ListWorkTypesResponseDto
     */
    data: Array<WorkTypeResponseDto>;
}

/**
 * Check if a given object implements the ListWorkTypesResponseDto interface.
 */
export function instanceOfListWorkTypesResponseDto(value: object): value is ListWorkTypesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListWorkTypesResponseDtoFromJSON(json: any): ListWorkTypesResponseDto {
    return ListWorkTypesResponseDtoFromJSONTyped(json, false);
}

export function ListWorkTypesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWorkTypesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(WorkTypeResponseDtoFromJSON)),
    };
}

export function ListWorkTypesResponseDtoToJSON(json: any): ListWorkTypesResponseDto {
    return ListWorkTypesResponseDtoToJSONTyped(json, false);
}

export function ListWorkTypesResponseDtoToJSONTyped(value?: ListWorkTypesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(WorkTypeResponseDtoToJSON)),
    };
}

